export class StorageHandler {
  static KEY_AUTH = 'authTokens';
  static KEY_USER = 'user';
  static KEY_REMEMBER = 'rememberMe';
  static KEY_TIMER_COUNTDOWN = 'timerCountDown';

  static rememberMeActive() {
    return localStorage.getItem(StorageHandler.KEY_REMEMBER) === 'true';
  }

  static setRememberMe(value: boolean) {
    localStorage.setItem(StorageHandler.KEY_REMEMBER, value.toString());
  }

  static timerCountdown() {
    return localStorage.getItem(StorageHandler.KEY_TIMER_COUNTDOWN);
  }

  static setTimerCountdown(value: string) {
    localStorage.setItem(StorageHandler.KEY_TIMER_COUNTDOWN, value);
  }

  static clearTimerCountdown() {
    if (StorageHandler.timerCountdown() != null) {
      localStorage.removeItem(StorageHandler.KEY_TIMER_COUNTDOWN);
    }
  }

  static getStorage(key: string) {
    if (StorageHandler.rememberMeActive()) {
      return localStorage.getItem(key);
    }
    return sessionStorage.getItem(key);
  }
  static async setStorage(key: string, value: string) {
    if (StorageHandler.rememberMeActive()) {
      localStorage.setItem(key, value);
      return;
    }
    sessionStorage.setItem(key, value);
  }

  static async removeStorage(key: string) {
    if (StorageHandler.rememberMeActive()) {
      localStorage.removeItem(key);
      return;
    }
    sessionStorage.removeItem(key);
  }

  static async clearStorage() {
    if (StorageHandler.rememberMeActive()) {
      localStorage.clear();
      return;
    }
    sessionStorage.clear();
  }
}
